import { Input } from 'antd';
import React from 'react';

const { Search } = Input;

const GNESearch = ({
  className,
  onSearch,
  onChange,
  value,
  placeholder,
  onClear,
}) => {
  return (
    <Search
      className={`gne-search ${className}`}
      onSearch={(value, _e, info) => {
        // With a modified clear (cross) icon, we don't receive a direct onClear event.
        // Use onSearch info.source === 'clear' to route the clear action.
        if (info.source === 'clear') {
          onClear();
        }
        onSearch(value, _e, info);
      }}
      onChange={(e) => onChange(e)}
      value={value}
      placeholder={placeholder}
      allowClear={{
        clearIcon: <i className='icon icon__close' />,
      }}
    />
  );
};

export default GNESearch;
